import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type GetLanguageRequest = RequestConfig;

export const getLanguage = async ({ config }: GetLanguageRequest) =>
  api.get<{ culture: string }>(`/api/User/culture`, config);
